export default class Carousel {
    carouselWrapper: HTMLElement | null
    carousel: HTMLElement
    cardWidth: number
    hasControls: boolean
    startX!: number
    startScrollLeft!: number
    autoPlay: boolean
    timeoutId!: NodeJS.Timeout
    speed: number

    isDragging = false

    constructor(carouselElement: string, {
        hasControls = false,
        autoPlay = false,
        speed = 2500

    } = {}) {
        this.carousel = document.querySelector(carouselElement) as HTMLElement;
        this.carouselWrapper = document.querySelector(".carousel-wrapper")
        this.hasControls = hasControls
        this.autoPlay = autoPlay
        this.speed = speed
        this.cardWidth = 0
        this.carouselSlider()
    }

    private carouselSlider(): void {
        this.preventImageDrag()
        this.addAttributeToCarouselChildren()
        this.cloneCards()
        this.autoPlay && this.autoScroll.bind(this)
        this.hasControls && this.handleArrowButtons()
        this.carousel?.addEventListener("mousedown", this.dragCardStart.bind(this))
        this.carousel?.addEventListener("mousemove", this.dragCard.bind(this))
        document.addEventListener("mouseup", this.dragCardStop.bind(this))
        this.carousel?.addEventListener("scroll", this.inifiniteScroll.bind(this))
        // this.carouselWrapper?.addEventListener("mouseenter", () => clearTimeout(this.timeoutId))
        // this.autoPlay && this.carouselWrapper?.addEventListener("mouseleave", this._autoPlay.bind(this))
    }

    static get controls() {
        return `
         <button id="prev" class="control">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" />
            </svg>
        </button>
        <button id="next" class="control">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
            </svg>
        </button>
        `
    }

    private get carouselChildren() {
        if (this.carousel) {
            return Array.from(this.carousel.children)
        }
    }


    private addAttributeToCarouselChildren(): void {
        const items = this.carouselChildren

        items && items.forEach(item => {
            item.setAttribute("data-class", "carousel-item")
        })
        const card = this.carousel?.querySelector("[data-class='carousel-item']") as HTMLElement
        this.cardWidth += card?.offsetWidth
    }

    private get cardPerView(): number {
        // const column = Math.floor(this.cardWrapper?.offsetWidth / widthToScroll.offsetWidth)
        // return Math.round(this.carousel?.offsetWidth / this.cardWidth)
        return Math.floor(this.carousel?.offsetWidth / this.cardWidth)
    }

    private cloneCards(): void {
        const reversedFirstFewCards = this.carouselChildren?.slice(0, this.cardPerView)
        const reversedLastFewCards = this.carouselChildren?.slice(-this.cardPerView).reverse()

        reversedFirstFewCards?.forEach(card => {
            this.carousel.insertAdjacentHTML("beforeend", card.outerHTML)
        })

        reversedLastFewCards?.forEach(card => {
            this.carousel.insertAdjacentHTML("afterbegin", card.outerHTML)
        })
    }

    private preventImageDrag(): void {
        if (this.carousel) {
            const images = Array.from(this.carousel.querySelectorAll("img") as NodeListOf<HTMLElement>)
            images.forEach(img => {
                img.setAttribute("draggable", 'false')
            })
        }
    }

    private handleArrowButtons(): void {
        this.carousel?.insertAdjacentHTML("beforebegin", Carousel.controls)
        const controls: NodeListOf<HTMLButtonElement> = document.querySelectorAll(".control")
        controls.forEach(btn => {
            btn.addEventListener("click", () => {
                this.carousel.scrollLeft += btn.id === "prev" ? -this.cardWidth : this.cardWidth
            })

        })

    }

    private dragCardStart(e: MouseEvent): void {
        this.isDragging = true
        this.carousel.classList.add("dragging")

        this.startX = e.pageX
        this.startScrollLeft = this.carousel.scrollLeft

    }

    private dragCard(e: MouseEvent): void {
        if (!this.isDragging) return
        this.carousel.scrollLeft = this.startScrollLeft - (e.pageX - this.startX)
    }

    private dragCardStop(): void {
        this.isDragging = false
        this.carousel?.classList.remove("dragging")
    }

    private inifiniteScroll() {
        const scrollLeft = Math.ceil(this.carousel?.scrollLeft)
        const scrollWidth = this.carousel.scrollWidth - this.carousel.offsetWidth
        const viewableArea = scrollLeft === scrollWidth
        if (this.carousel?.scrollLeft === 0) {
            this.carousel.classList.add("no-transition")
            this.carousel.scrollLeft = this.carousel.scrollWidth - (3 * this.carousel.offsetWidth)
            this.carousel.classList.remove("no-transition")
        } else if (viewableArea) {
            this.carousel.classList.add("no-transition")
            this.carousel.scrollLeft = this.carousel.offsetWidth
            this.carousel.classList.remove("no-transition")

        }
        clearTimeout(this.timeoutId)
        if (!this.carouselWrapper?.matches(":hover")) this.autoScroll()
    }

    private autoScroll() {
        // if (window.innerWidth < 800) return
        // window.requestAnimationFrame(() => this.carousel.scrollTo({ left: this.carousel.scrollLeft += this.cardWidth, behavior: 'smooth' }))
        this.timeoutId = setTimeout(() => { this.carousel.scrollLeft += this.cardWidth }, this.speed)
    }
}

// interface CarouselInterface {
//     arrowPrevClass?: string,
//     arrowNextClass?: string,
//     hasControls?: boolean,
//     speed?: number
// }

// export default class Carousel {
//     cardWrapper: HTMLElement
//     arrowPrevClass: string
//     arrowNextClass: string
//     hasControls: boolean
//     speed: number
//     // private cardWrapper = document.querySelector('.card-wrapper') as HTMLElement
//     // private cardImageAndLink = this.cardWrapper.querySelectorAll('img, a') as NodeListOf<HTMLElement>
//     // private cardWrapperChildren = Array.from(this.cardWrapper.children)
//     // private widthToScroll = this.cardWrapper.children[0] as HTMLElement
//     // private arrowPrev = document.querySelector('.arrow.prev') as HTMLElement
//     // private arrowNext = document.querySelector('.arrow.next') as HTMLElement

//     constructor(carousel: string, {
//         arrowPrevClass = '.arrow.next',
//         arrowNextClass = '.arrow.prev',
//         hasControls = false,
//         speed = 4000
//     }: CarouselInterface) {
//         this.cardWrapper = document.querySelector(carousel) as HTMLElement
//         this.arrowPrevClass = arrowPrevClass
//         this.arrowNextClass = arrowNextClass
//         this.hasControls = hasControls
//         this.speed = speed

//         this.init()
//     }

//     private init() {
//         this.carouselSlider()
//     }

//     static arrowHTML(): string {
//         return `
//          <button class="arrow prev">
//             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
//                 <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z" />
//             </svg>
//         </button>
//         <button class="arrow next">
//             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
//                 <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z" />
//             </svg>
//         </button>
//         `
//     }

//     private carouselSlider(): void {
//         const widthToScroll = this.cardWrapper?.children[0] as HTMLElement
//         const cardImageAndLink = this.cardWrapper?.querySelectorAll('img, a') as NodeListOf<HTMLElement>
//         const cardBouncing = this.cardWrapper?.getBoundingClientRect()
//         const cardWrapperChildren = this.cardWrapper && Array.from(this.cardWrapper.children)
//         const column = Math.floor(this.cardWrapper?.offsetWidth / widthToScroll.offsetWidth)

//         let currentScroll = 0
//         let initPos = 0
//         let clicked = false

//         cardWrapperChildren?.slice(-column).reverse().forEach((child) => {
//             this.cardWrapper?.insertAdjacentHTML('afterbegin', child.outerHTML)
//         })

//         cardWrapperChildren?.slice(0, column).forEach((child) => {
//             this.cardWrapper?.insertAdjacentHTML('beforeend', child.outerHTML)
//         })

//         cardImageAndLink.forEach(item => item.setAttribute('draggable', 'false'))


//         this.cardWrapper?.classList.add("noSmooth")
//         this.cardWrapper.scrollLeft = this.cardWrapper?.offsetWidth
//         this.cardWrapper?.classList.remove("noSmooth")


//         if (this.hasControls) {
//             this.cardWrapper?.insertAdjacentHTML('beforebegin', Carousel.arrowHTML())
//             const arrowPrev = document.querySelector('.arrow.prev' || this.arrowPrevClass) as HTMLElement
//             const arrowNext = document.querySelector('.arrow.next' || this.arrowNextClass) as HTMLElement

//             arrowPrev.addEventListener('click', () => {
//                 this.cardWrapper.scrollLeft += widthToScroll.offsetWidth
//             })

//             arrowNext.addEventListener('click', () => {
//                 this.cardWrapper.scrollLeft -= widthToScroll.offsetWidth
//             })
//         }

//         this.cardWrapper?.addEventListener('mousedown', (e) => {
//             this.cardWrapper?.classList.add("grab")
//             initPos = e.clientX - cardBouncing?.left
//             currentScroll = this.cardWrapper.scrollLeft
//             clicked = true
//         })

//         this.cardWrapper?.addEventListener('mousemove', (e) => {
//             if (clicked) {
//                 const xPos = e.clientX - cardBouncing?.left
//                 this.cardWrapper.scrollLeft = currentScroll + -(xPos - initPos)
//             }

//         })

//         const mouseUpAndLeave = () => {
//             this.cardWrapper?.classList.remove('grab')
//             clicked = false;
//         }

//         this.cardWrapper?.addEventListener('mouseup', mouseUpAndLeave)
//         this.cardWrapper?.addEventListener('mouseleave', mouseUpAndLeave)

//         let autoscroll: NodeJS.Timeout

//         this.cardWrapper?.addEventListener('scroll', () => {

//             if (this.cardWrapper.scrollLeft === 0) {
//                 this.cardWrapper?.classList.add("noSmooth")
//                 this.cardWrapper.scrollLeft = this.cardWrapper.scrollWidth - (3 * this.cardWrapper.offsetWidth)
//                 this.cardWrapper?.classList.remove("noSmooth")
//             } else if (this.cardWrapper.scrollLeft === this.cardWrapper?.scrollWidth - this.cardWrapper?.offsetWidth) {
//                 this.cardWrapper?.classList.add("noSmooth")
//                 this.cardWrapper.scrollLeft = this.cardWrapper?.offsetWidth
//                 this.cardWrapper?.classList.remove("noSmooth")
//             }

//             if (autoscroll) {
//                 clearTimeout(autoscroll)
//             }

//             autoscroll = setTimeout(() => {
//                 this.cardWrapper.scrollLeft += widthToScroll.offsetWidth
//             }, this.speed)

//         })
//     }

// }


